<div class="container">
  <div>
    Продолжая пользоваться Порталом открытых данных Правительства Москвы, вы соглашаетесь на обработку файлов cookie и соответствующих пользовательских данных в целях функционирования сайта и анализа его использования.
    <a target="_blank" href="https://www.mos.ru/dit/documents/informatcionnaia-bezopasnost/view/274898220/">Подробнее</a>
  </div>

  <button class="btn-empty" (click)="close()">Принять</button>
</div>
